// extracted by mini-css-extract-plugin
export default {"buttonContainer":"DashboardMobileWriteArticleButton_buttonContainer__xcwGx","button":"DashboardMobileWriteArticleButton_button__qvzls"};